import { recordConsent, fetchAndStoreUserIP } from "./consentApi"

const CATEGORIES = [
  ["necessary", ["essential", "necessary", "strictly"]],
  ["performance", ["performance"]],
  ["analytics", ["analytic"]],
  ["functional", ["functional"]],
  ["advertising", ["advertis", "marketing", "targeting"]],
]

let lastSent = 0

function categoryFor(text) {
  const lower = text.toLowerCase()
  const match = CATEGORIES.find(([, words]) =>
    words.some(word => lower.includes(word))
  )
  return match ? match[0] : null
}

function labelFor(toggle) {
  if (toggle.id) {
    const label = document.querySelector(`label[for="${toggle.id}"]`)
    if (label && label.textContent.trim()) return label.textContent.trim()
  }
  let el = toggle.parentElement
  for (let i = 0; i < 4 && el; i++) {
    const text = el.textContent.trim()
    if (text) return text
    el = el.parentElement
  }
  return toggle.getAttribute("name") || toggle.id || ""
}

function readToggles() {
  const container = document.getElementById("preference_container")
  if (!container) return []
  const toggles = container.querySelectorAll(
    'input[type="checkbox"], [role="switch"], [aria-checked]'
  )
  return Array.from(toggles).map(toggle => ({
    label: labelFor(toggle).replace(/\s+/g, " ").slice(0, 100),
    checked:
      toggle.type === "checkbox"
        ? toggle.checked
        : toggle.getAttribute("aria-checked") === "true",
  }))
}

function buildPrefs(choice, options) {
  const prefs = { necessary: true, performance: false, analytics: false }
  options.forEach(option => {
    const category = categoryFor(option.label)
    if (category && category !== "necessary") prefs[category] = false
  })
  Object.keys(prefs).forEach(key => {
    if (key === "necessary") return
    if (choice === "accept_all") prefs[key] = true
  })
  if (choice === "custom") {
    options.forEach(option => {
      const category = categoryFor(option.label)
      if (category && category !== "necessary") prefs[category] = option.checked
    })
  }
  return prefs
}

function handleClick(event) {
  const target = event.target.closest(
    '[role="button"], button, input[type="button"], input[type="submit"]'
  )
  if (!target || !target.closest("#consent_container")) return
  if (target.id === "preference" || target.id === "close") return

  const text = (target.textContent || target.value || "").trim().toLowerCase()
  const inPreferences = Boolean(target.closest("#preference_container"))
  let choice
  if (
    text.includes("essential only") ||
    text.includes("reject") ||
    text.includes("decline") ||
    text.includes("deny")
  ) {
    choice = "reject_all"
  } else if (inPreferences) {
    choice = "custom"
  } else if (target.id === "accept_all" || text.includes("accept")) {
    choice = "accept_all"
  } else {
    return
  }

  const now = Date.now()
  if (now - lastSent < 1000) return
  lastSent = now

  const options = readToggles()
  recordConsent({
    prefs: buildPrefs(choice, options),
    source: "zoho-banner",
    choice,
    options,
  })
}

export function startZohoConsentTracking() {
  if (typeof window === "undefined") return
  fetchAndStoreUserIP()
  document.addEventListener("click", handleClick, true)
}